import { getGlobalSettings } from '../../../utils/global_settings';
import { differenceInDays } from '../../../utils/date';
import { URL_SYNCED_PARAMS } from './constants';

export const rootNode = document.getElementById('publisher-page-root');

const parseJSON = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
};

const urlFilters = (() => {
  const searchParams = new URLSearchParams(window.location.search);

  return URL_SYNCED_PARAMS.reduce((acc, paramName) => {
    const value = searchParams.get(paramName);
    return value ? { ...acc, [paramName]: value } : acc;
  }, {});
})();

const defaultInitParams = {
  store: '',
  id: '',
  permissions: {},
  currentUser: {},
  filters: {},
  appsFilters: {},
  maxPeriod: 365,
  maxDate: null,
};

export const initParams = (() => {
  if (!rootNode) return defaultInitParams;

  const periodFilters = parseJSON(rootNode.dataset.periodFilters, {});
  const hasCustomDates = !!(urlFilters.period_from_date && urlFilters.period_to_date);

  return {
    store: rootNode.dataset.store || '',
    id: rootNode.dataset.id || '',
    permissions: {
      ...(getGlobalSettings().permissions || {}),
      ...parseJSON(rootNode.dataset.permissions, {}),
    },
    currentUser: getGlobalSettings().currentUser || {},
    filters: {
      period: hasCustomDates
        ? differenceInDays(urlFilters.period_to_date, urlFilters.period_from_date) + 1
        : parseInt(urlFilters.period || periodFilters.period, 10) || 30,
      period_from_date: hasCustomDates
        ? urlFilters.period_from_date
        : periodFilters.period_from_date || null,
      period_to_date: hasCustomDates
        ? urlFilters.period_to_date
        : periodFilters.period_to_date || null,
    },
    appsFilters: {
      metric: urlFilters.metric || null,
      order: urlFilters.order || null,
      offset: parseInt(urlFilters.offset, 10) || 0,
    },
    maxPeriod: parseInt(periodFilters.maxPeriod, 10) || 365,
    maxDate: periodFilters.maxDate || null,
  };
})();
